import React, {Component, createRef} from "react";
import { connect } from "react-redux";
import eventBus from "../../../../../core/utils/EventBus";
import Storage from "../../../../../helpers/Storage";
import Button from "../../../../../shared/component/button/Button";
import CheckBox from "../../../../../shared/component/CheckBox/CheckBox";
import T from "../../../../../shared/component/t/T";
import {default as _} from "../../../../../helpers/Translate";
import StudyFilter from "../../Study-Filter-Modal/StudyFilter";
import snippets from "../../../../../helpers/snippets";
import StudyFiltersManagements from "../../StudyFiltersManagements/StudyFiltersManagements";
import StudyFiltersDesktop from "../../StudyFiltersDesktop/StudyFiltersDesktop";
import BaseApi from "../../../../../core/api/BaseApi";
import ModalConfirmation from "../../../../../shared/component/ModalConfirmation/ModalConfirmation";
import User from "../../../../../helpers/User";

const baseApi = new BaseApi()

class NavbarPart1 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      device: this.props.device,
      myReports: false,
      like: false,
      language: this.props.language,
      study_filters: Storage.getStudyFilters(),
      study_filter_options: [],
      study_filter_selected: -1,
      study_filter_selected_info: {},
      study_filter_create_modal: false,
      study_filter_delete_modal: false,
      study_filter_delete: {},
      study_filter_showAll_modal: false,
      study_filter_showAll_modal_desktop: false,
      study_filter_showFilterDetail: null,
      // used this variable to prevent closing main desktop menu (study_filter_showAll_modal_desktop when details/create/details modal open
      // we make this false whit delay to ensure that details/create/details are permanently closed
      skipDesktopToClose: false
    };
  }

  UNSAFE_componentWillMount() {
    this.initFilters()
  }

  componentDidMount() {
    eventBus.on("resetAllFilters", this.resetFilters);
    eventBus.on("refreshStudyFilters", this.updateFilters);
    eventBus.on("NavbarCheckFiltersAndStudyFilter", this.NavbarCheckFiltersAndStudyFilter);
    eventBus.on("NavbarStudyFilterChanges", this.study_filters_changes);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.language !== this.props.language) {
        this.setState({language: this.props.language});
    }
    if (prevProps.device !== this.props.device) {
        this.setState({device: this.props.device});
    }
    if (prevState.study_filter_delete_modal !== this.state.study_filter_delete_modal && this.state.study_filter_delete_modal === false) {
        setTimeout(()=> {this.setState({skipDesktopToClose: false})},100)
    }
    if (prevState.study_filter_create_modal !== this.state.study_filter_create_modal && this.state.study_filter_create_modal === false) {
        setTimeout(()=> {this.setState({skipDesktopToClose: false})},100)
    }
  }

  componentWillUnmount() {
    eventBus.remove("resetAllFilters");
    eventBus.remove("refreshStudyFilters");
    eventBus.remove("NavbarCheckFiltersAndStudyFilter");
    eventBus.remove("NavbarStudyFilterChanges");
  }

  NavbarCheckFiltersAndStudyFilter = (data) => {
    //TODO : select filter if user manually select one of filters
    if (this.state.study_filter_selected === -1) return
    let filter = Storage.getStudyFilters().find(item => item.id === this.state.study_filter_selected)?.filters_json
    if (snippets.areObjectsEqual(filter, data) === false){
      this.setState({study_filter_selected: -1})
    }
  }

  // Private methods
  #stateSetter = (newState = {}, callBackFn = () => {}) => {
    this.setState({
      ...newState
    }, callBackFn);
  }

  resetFilters = () => {
    this.#stateSetter({
      myReports: false,
      like: false,
      study_filter_selected: -1
    });
  }

  handleCheckBoxes = (data) => {
    this.setState({
      [data.name]: data.checked
    }, () => {
      eventBus.dispatchEvent("filterByLikeOrMy", {[data.name]: data.checked});
    });
  }

  /**
   * @param {list} data it use on other component to use it to update after deleting one of study filters
   */
  initFilters=(data = null)=>{
    let filters = {id: -1, value: -1, text: "choose_study_filter"}
    filters = [filters, ...Object.values(data ?? this.state.study_filters).map((item)=>{
      return {id: item.id, value: item.id, text: item.title, filters_json: item.filters_json}
    }), {id: -2, value: -2, text: "new_study_filter_add_current"}]
    this.setState({study_filter_options: filters})
  }

  updateFilters = () => {
    this.initFilters(Storage.getStudyFilters())
    this.study_filters_changes("-1")
  }

  study_filters_changes =(event)=>{
    this.setState({
      study_filter_selected: parseInt(event),
    })
    switch (event){
      case "-1":
        eventBus.dispatchEvent("ListHeaderReset", "");
        this.setState({study_filter_create_modal: false, study_filter_showAll_modal: false})
        break;
      case "-2":
        this.setState({study_filter_selected: -1, study_filter_showFilterDetail: null, study_filter_create_modal: true, study_filter_showAll_modal: false})
        break;
      default:
        let id = parseInt(event)
        let res = this.state.study_filter_options.find((item) => item.id === id)?.filters_json
        this.setState({study_filter_showAll_modal: false, study_filter_selected_info: res})
        eventBus.dispatchEvent("ListHeaderFilter", res);
    }
  }

  closeStudyFilterCreate = (response) => {
    this.setState({study_filter_create_modal: false},()=>{
      if (response){
        this.setState({study_filters: [...this.state.study_filters, response]},()=>{
          Storage.addOneNewStudyFilter(response)
          this.initFilters()
        })
      }
    })
  }

  handleWindows = () => {
    return this.state.study_filter_create_modal === true ? true : this.state.study_filter_delete_modal === true ? true : this.state.skipDesktopToClose
  }
  openStudyFilterListModal = () =>{
    this.setState({study_filter_showAll_modal: true})
  }

  closeStudyFilterListModalDesktop = () =>{
    this.setState({study_filter_showAll_modal_desktop: false}, ()=>{})
  }

  handleStudyFilterListModalDesktop = () =>{
    this.setState((prevState) => ({ study_filter_showAll_modal_desktop: !prevState.study_filter_showAll_modal_desktop }),
        ()=>{});
  }

  resetStudyFilterListModal = () =>{
    this.study_filters_changes("-1")
  }

  closeStudyFilterListModal = () =>{
    this.setState({study_filter_showAll_modal: false}, ()=>{})
  }

  studyFilterDetails = (item) =>{
    this.setState({study_filter_showFilterDetail: item, study_filter_create_modal: true, skipDesktopToClose: true}, ()=>{})
  }

  closeStudyFilterDetails = () =>{
    this.setState({study_filter_showFilterDetail: null, study_filter_create_modal: false}, ()=>{})
  }

  studyFilterApply = (id) =>{
    this.study_filters_changes(id)
  }

  studyFilterDefault = (id) =>{
    return baseApi.fullFetch("login", "put", {data: {default_study_filter_id: id}, showMessageSuccess: true}).then(()=>{
      Storage.setDefaultStudyFilterID(id)
    })
  }

  studyFilterDelete = (item) => {
    this.setState({study_filter_delete_modal: true, study_filter_delete: item, skipDesktopToClose: true},
        ()=>{})
  }

  studyFilterDeleteClose = () => {
    this.setState({study_filter_delete_modal: false, study_filter_delete: null})
  }

  studyFilterDeleteConfirmed = (item) => {
    return baseApi.fullFetch("study_filters", "delete", {data: {id: item.id}, showMessageSuccess: true}).then(()=>{
      Storage.removeOneStudyFilter(item.id)
      eventBus.dispatchEvent("refreshStudyFilters")
    })
  }

  handleStudyFilter = (studyFilters) => {
    let studyFilterText = this.state.study_filter_options?.find(item=> item.id === parseInt(this.state.study_filter_selected))?.text
    let defaultStudyFilterID = Storage.getDefaultStudyFilterID()
    let defaultStudyFilter = this.state.study_filter_options?.find(item=> item.id?.toString() === defaultStudyFilterID?.toString())

    return <>
      {this.state.device === "desktop" && <>
        <div className={"studyFilter__down_menu"} >
          <Button className={`study_filters`}
                  size="small"
                  customClasses="margin-2px"
                  mode="gray-new"
                  key={0}
                  onClick={this.handleStudyFilterListModalDesktop}
                  style={{position: "relative"}}
          >
            {this.state.study_filter_showAll_modal_desktop ?
                <i className={"fa fa-angle-up"} />
                :
                <i className={"fa fa-angle-down"} />
            }
          </Button>

          <StudyFiltersDesktop show={this.state.study_filter_showAll_modal_desktop}
                               onClose={this.closeStudyFilterListModalDesktop}
                               otherWindows={this.handleWindows}
                               data={Object.assign({},
                                   {filters: studyFilters},
                                   {defaultID: defaultStudyFilterID ?? undefined},
                                   {selected: this.state.study_filter_selected}
                               )}
                               functions={Object.assign({},
                                   {apply: this.studyFilterApply},
                                   {add: ()=>this.study_filters_changes("-2")},
                                   {details: this.studyFilterDetails},
                                   {changeDefault: this.studyFilterDefault},
                                   {delete: this.studyFilterDelete}
                               )}
          />
        </div>
        {defaultStudyFilter &&
            <Button className={`study_filters ${this.state.study_filter_selected.toString() === defaultStudyFilterID.toString() ? "selected" : ""}`}
                    size="small"
                    customClasses="margin-2px"
                    mode="gray-new"
                    key={1}
                    onClick={() => this.study_filters_changes(defaultStudyFilterID)}
            >
              <T token={defaultStudyFilter?.text} />
            </Button>
        }
      </>}


      {this.state.device !== "desktop" &&
          <Button className={`study_filters ${this.state.study_filter_selected !== -1 ? "selected" : ""}`}
                  size="small"
                  customClasses="margin-2px"
                  mode="gray-new"
                  key={2}
                  onClick={this.openStudyFilterListModal}
          >
            <T token={studyFilterText} />
          </Button>
      }
    </>
  }

  render() {
    let studyFilters = this.state.study_filter_options.filter(item => item.id.toString() !== "-1" && item.id.toString() !== "-2")

    return <>
      { User.canViewStudyFilter() && this.handleStudyFilter(studyFilters)}

      {/*<Button className={"report_search"} size="small" customClasses="margin-2px" mode="gray-new" key={2}*/}
      {/*        onClick={this.reportSearch} tooltip={_.init("search_in_report", this.state.language)}>*/}
      {/*  <T token={"search_in_report"} />*/}
      {/*</Button>*/}

      <CheckBox type="complex"
                disableMainLabel={true}
                name="myReports"
                value={1}
                labelText="my_reports"
                handleChangeValue={this.handleCheckBoxes}
                checked={this.state.myReports}
                icon="fal fa-info-circle"
                tooltipWithIcon={_.init("my_reports_help", this.state.language)} />
      <CheckBox type="complex"
                disableMainLabel={true}
                name="like"
                value={"like"}
                labelText="like"
                handleChangeValue={this.handleCheckBoxes}
                checked={this.state.like}
                icon="fal fa-info-circle"
                tooltipWithIcon={_.init("similarity_help", this.state.language)} />

      {this.state.study_filter_create_modal && <StudyFilter show={this.state.study_filter_create_modal}
                                                            onClose={this.closeStudyFilterCreate}
                                                            data={this.state.study_filter_options?.find(item => item.id === this.state.study_filter_showFilterDetail?.id)}
      />}

      {this.state.study_filter_showAll_modal &&  <StudyFiltersManagements show={this.state.study_filter_showAll_modal}
                                                                          onClose={this.closeStudyFilterListModal}
                                                                          studyFilterOptions={studyFilters}
                                                                          studyFilterSelected={this.state.study_filter_selected}
                                                                          studyFilterChanges={this.study_filters_changes}
                                                                          studyFilterReset={this.resetStudyFilterListModal}
                                                                          studyFilterApply={this.studyFilterApply}
                                                                          studyFilterDelete={this.studyFilterDeleteConfirmed}
                                                                          studyFilterDeafult={this.studyFilterDefault}
                                                                          showDetails={this.studyFilterDetails}
                                                                          showDelete={this.studyFilterDelete}
      />}

      {this.state.study_filter_delete_modal && <ModalConfirmation show={this.state.study_filter_delete_modal}
                                                            onClose={this.studyFilterDeleteClose}
                                                            className={"delete_study_filter"}
                                                            title={_.init4("delete_study_filter_confirmation_with_name", {name: this.state.study_filter_delete?.text})}
                                                            item={this.state.study_filter_delete}
                                                            onConfirm={this.studyFilterDeleteConfirmed}
                                                            confirmText={'delete_template'}
      />}

    </>
  }
}

const mapStateToProps = state => {
  const language = state.LangReducer.language;
  const device = state.DeviceModeReducer.mode;
  return {language, device};
};

export default connect(mapStateToProps)(NavbarPart1);
